// extracted by mini-css-extract-plugin
module.exports = {"ulClass":"twoColumnList-module--ulClass--3L-FO","liClass":"twoColumnList-module--liClass--R9kki"};